import styled, { css } from "styled-components"

export const Button = styled.button`
  position: relative;

  //width: ${props => (props.width === "100%" ? "100%" : `${props.width}px`)};
  height: ${props => props.height}px;

  margin: auto;

  background-color: ${props => (props.$isAltColour ? props.theme.colours.black : props.theme.colours.main)};
  border: ${props => (props.$isAltColour ? "2px solid #B19661" : "none")};
  border-radius: 32px;

  font-family: ${props => props.theme.fonts.primary};
  font-size: ${props => props.fontSize};
  font-weight: 700;
  text-transform: uppercase;
  text-decoration: none;
  text-align: center;
  ${props =>
    !props.$isButton &&
    css`
      line-height: ${props.height}px;
    `}
  color: #000;

  cursor: pointer;

  padding: 0 32px;

  ${({ icon, $isAltColour, theme: { colours } }) =>
    icon &&
    css`
      padding: 10px 32px 10px 32px;

      background: url(${icon}) ${$isAltColour ? colours.black : colours.main};
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: 87% 50%;

      text-align: left;
    `}

  :disabled {
    opacity: 0.5;

    cursor: initial;
  }
`
